import InspectionWizard from "./InspectionWizard";
import { labelCategorie } from "./VehiculesListe";
import { formaterDate } from "../format";
import {
  VERDICTS, decoderConclusion, encoderConclusion, nettoyerEntier, nettoyerDecimal, estVide,
  ChampLecture,
} from "./champsInspection";

// Les messages de la coquille partagee, au vocabulaire de la VGP (H1).
const VOCABULAIRE_VGP = {
  ajoutImpossible: "Ajout de l'observation impossible.",
  enregistrementImpossible: "Enregistrement de l'observation impossible.",
  titreSuppression: "Supprimer cette observation ?",
  pluriel: "observations",
};

const ETAPES = [
  // H3 (28/09/2026) : la conclusion QUITTE l'etape 1. On ne conclut pas avant
  // d'avoir regarde -- retour d'une visite client.
  { num: 1, titre: "Nature du contrôle" },
  { num: 2, titre: "Identification véhicule" },
  { num: 3, titre: "Identification hayon" },
  { num: 4, titre: "Contrôleur" },
  // H1 + H4 (28/09/2026) : « Observations », pas « Défauts ». Un defaut
  // accuse ; une observation decrit -- un controleur qui note une usure normale
  // ne « constate pas un defaut ». VGP SEULEMENT : le CT garde son vocabulaire.
  { num: 5, titre: "Observations constatées" },
  { num: 6, titre: "Essais de fonctionnement" },
  { num: 7, titre: "Photos, récapitulatif & conclusion" },
];

const CHAMPS_VGP = [
  "livret_securite_present", "essai_a_vide_resultat", "essai_en_charge_resultat", "charge_nominale_kg",
];
const BLOCS = [{ cle: "vgp_details", champs: CHAMPS_VGP }];

function valider(numero, form) {
  if (!form) return [];
  const e = [];
  // H3 : la conclusion est requise a l'etape 7, la ou elle se donne. Comme
  // `finaliser` valide l'etape COURANTE -- la 7 --, on ne peut toujours pas
  // finaliser sans conclusion. Le serveur l'exige aussi (`finaliser`, 400).
  if (numero === 7) {
    if (estVide(form.conclusion)) e.push("La conclusion est requise.");
  } else if (numero === 2) {
    if (estVide(form.kilometrage_releve)) e.push("Le kilométrage relevé est requis.");
  } else if (numero === 4) {
    if (!String(form.controleur_nom ?? "").trim()) e.push("Le nom du contrôleur est requis.");
    if (!String(form.controleur_entreprise ?? "").trim()) {
      e.push("L'entreprise du contrôleur est requise.");
    }
  } else if (numero === 6) {
    if (!String(form.details?.essai_a_vide_resultat ?? "").trim()) {
      e.push("Le résultat de l'essai à vide est requis.");
    }
    if (!String(form.details?.essai_en_charge_resultat ?? "").trim()) {
      e.push("Le résultat de l'essai en charge est requis.");
    }
  }
  return e;
}

function renderEtape(etape, ctx) {
  const {
    form, ro, vehicule, majTronc, majDetails, modifiable,
    defauts, ajouterDefaut, majDefautLocal, sauverDefaut, supprimerDefaut,
    photos, apercus, onUploadPhotos, majLegendeLocale, sauverLegende, supprimerPhoto,
  } = ctx;
  const majConclusion = (verdict, commentaire) =>
    majTronc("conclusion", encoderConclusion(verdict, commentaire));

  if (etape === 1) {
    return (
      <>
        <div className="grille-form">
          <label>
            Nature du contrôle
            <input value="Vérification Générale Périodique (VGP)" readOnly disabled />
          </label>
          {/* H2 (28/09/2026) — LE NUMERO EST ATTRIBUE PAR LE SERVEUR, a la
              finalisation : `150926-5` pour la 5e VGP du client ce jour-la.
              Il se tapait a la main, et la production portait deja une faute
              de frappe sur un rapport remis (`15092026-4`). Verrouille : le
              serveur ignore de toute facon ce champ pour une VGP. */}
          <div className="champ-verrouille-wrapper">
            <span className="champ-verrouille-label">N° de contrôle</span>
            <div className="champ-verrouille-valeur">
              {form.numero_controle || "—"}
              <span className="champ-verrouille-mention">
                {form.numero_controle
                  ? "attribué automatiquement"
                  : "attribué automatiquement à la finalisation"}
              </span>
            </div>
          </div>
          <div className="champ-verrouille-wrapper">
            <span className="champ-verrouille-label">Date du contrôle</span>
            <div className="champ-verrouille-valeur">
              {form.date_controle ? formaterDate(form.date_controle) : "—"}
              <span className="champ-verrouille-mention">fixée automatiquement à la création</span>
            </div>
          </div>
          <label>
            Heure du contrôle
            <input type="time" value={(form.heure_controle || "").slice(0, 5)} disabled={ro}
              onChange={(e) => majTronc("heure_controle", e.target.value)} />
          </label>
          <label>
            Validité (mois)
            <input inputMode="numeric" value={form.validite_mois} disabled={ro}
              onChange={(e) => majTronc("validite_mois", nettoyerEntier(e.target.value))} />
          </label>
        </div>
      </>
    );
  }

  if (etape === 2) {
    return (
      <>
        <div className="grille-champs">
          <ChampLecture label="Immatriculation" valeur={vehicule?.immatriculation} />
          <ChampLecture label="Marque" valeur={vehicule?.marque} />
          <ChampLecture label="N° châssis" valeur={vehicule?.n_chassis} />
          <ChampLecture label="Type / modèle" valeur={vehicule?.type_modele} />
          <ChampLecture label="Catégorie" valeur={vehicule ? labelCategorie(vehicule.categorie) : ""} />
        </div>
        <div className="grille-form bloc-saisie">
          <label>
            Kilométrage relevé au contrôle *
            <input inputMode="numeric" value={form.kilometrage_releve} disabled={ro}
              onChange={(e) => majTronc("kilometrage_releve", nettoyerEntier(e.target.value))} />
          </label>
        </div>
      </>
    );
  }

  if (etape === 3) {
    const h = vehicule?.equipement_hayon || {};
    return (
      <>
        <p className="note-info">
          Données reprises de la fiche hayon du véhicule. Un champ « Non renseigné » signale une
          donnée manquante (à compléter sur la fiche véhicule si nécessaire).
        </p>
        <div className="grille-champs">
          <ChampLecture label="Marque" valeur={h.marque} />
          <ChampLecture label="Type" valeur={h.type} />
          <ChampLecture label="N° série" valeur={h.n_serie} />
          <ChampLecture label="Année" valeur={h.annee} />
          <ChampLecture label="Capacité de levage (kg)" valeur={h.capacite_levage_kg} />
          <ChampLecture label="Centre de gravité (mm)" valeur={h.centre_gravite_mm} />
          <ChampLecture label="Pression limiteur (bar)" valeur={h.pression_limiteur_bar} />
          <ChampLecture label="Arrêt de rolls"
            valeur={h.arret_de_rolls === true ? "Oui" : h.arret_de_rolls === false ? "Non" : null} />
        </div>
      </>
    );
  }

  if (etape === 4) {
    return (
      <>
        <div className="grille-form">
          <label>
            Nom *
            <input value={form.controleur_nom} disabled={ro}
              onChange={(e) => majTronc("controleur_nom", e.target.value)} />
          </label>
          <label>
            Prénom
            <input value={form.controleur_prenom} disabled={ro}
              onChange={(e) => majTronc("controleur_prenom", e.target.value)} />
          </label>
          <label>
            Entreprise *
            <input value={form.controleur_entreprise} disabled={ro}
              onChange={(e) => majTronc("controleur_entreprise", e.target.value)} />
          </label>
          <label>
            Cachet entreprise
            <input value={form.cachet_entreprise} disabled={ro}
              onChange={(e) => majTronc("cachet_entreprise", e.target.value)} />
          </label>
        </div>
        <fieldset className="groupe-radio">
          <legend>Livret de sécurité présent</legend>
          <label className="option-radio">
            <input type="radio" name="livret" checked={form.details.livret_securite_present === true}
              disabled={ro} onChange={() => majDetails("livret_securite_present", true)} />
            Oui
          </label>
          <label className="option-radio">
            <input type="radio" name="livret" checked={form.details.livret_securite_present === false}
              disabled={ro} onChange={() => majDetails("livret_securite_present", false)} />
            Non
          </label>
        </fieldset>
      </>
    );
  }

  if (etape === 5) {
    const tries = [...defauts].sort((a, b) => a.numero_ordre - b.numero_ordre);
    return (
      <>
        <p className="note-info">
          Consignez les observations constatées. Aucune observation = liste vide (rien à signaler).
        </p>
        {tries.length === 0 ? (
          <p className="vide">Aucune observation constatée.</p>
        ) : (
          <ol className="defauts-liste">
            {tries.map((d, i) => (
              <li key={d.id} className="defaut-ligne">
                <span className="defaut-num">{i + 1}/</span>
                <input value={d.description ?? ""} disabled={ro} placeholder="Description de l'observation"
                  onChange={(e) => majDefautLocal(d.id, e.target.value)} onBlur={() => sauverDefaut(d)} />
                {!ro && (
                  <button type="button" className="lien-action lien-danger"
                    onClick={() => supprimerDefaut(d)}>Supprimer</button>
                )}
              </li>
            ))}
          </ol>
        )}
        {!ro && (
          <button type="button" className="btn" onClick={ajouterDefaut}>+ Ajouter une observation</button>
        )}
      </>
    );
  }

  if (etape === 6) {
    return (
      <div className="grille-form">
        <label>
          Fonctionnement à vide — résultat *
          <input value={form.details.essai_a_vide_resultat ?? ""} disabled={ro} placeholder="ex. Conforme"
            onChange={(e) => majDetails("essai_a_vide_resultat", e.target.value)} />
        </label>
        <label>
          Fonctionnement en charge — résultat *
          <input value={form.details.essai_en_charge_resultat ?? ""} disabled={ro} placeholder="ex. Conforme"
            onChange={(e) => majDetails("essai_en_charge_resultat", e.target.value)} />
        </label>
        <label>
          Charge nominale (kg)
          <input inputMode="decimal" value={form.details.charge_nominale_kg ?? ""} disabled={ro}
            onChange={(e) => majDetails("charge_nominale_kg", nettoyerDecimal(e.target.value))} />
        </label>
      </div>
    );
  }

  if (etape === 7) {
    const { verdict, commentaire } = decoderConclusion(form.conclusion);
    const h = vehicule?.equipement_hayon || {};
    const defautsTries = [...defauts].sort((a, b) => a.numero_ordre - b.numero_ordre);
    const livret =
      form.details.livret_securite_present === true ? "Oui"
        : form.details.livret_securite_present === false ? "Non" : null;
    return (
      <>
        <div className="recap-bloc">
          <h5>Photos</h5>
          {!ro && (
            <label className="zone-upload">
              <input type="file" accept="image/jpeg,image/png,image/webp" multiple onChange={onUploadPhotos} />
              <span>+ Ajouter des photos (JPEG, PNG, WebP — 10 Mo max)</span>
            </label>
          )}
          {photos.length === 0 ? (
            <p className="vide">Aucune photo.</p>
          ) : (
            <div className="photos-grille">
              {photos.map((p) => (
                <div key={p.id} className="photo-carte">
                  {apercus[p.id] ? (
                    <img src={apercus[p.id]} alt={p.legende || "Photo d'inspection"} />
                  ) : (
                    <div className="photo-vide">Chargement…</div>
                  )}
                  <input className="photo-legende" value={p.legende ?? ""} disabled={ro}
                    placeholder="Légende (optionnel)"
                    onChange={(e) => majLegendeLocale(p.id, e.target.value)}
                    onBlur={() => sauverLegende(p)} />
                  {!ro && (
                    <button type="button" className="lien-action lien-danger"
                      onClick={() => supprimerPhoto(p)}>Supprimer</button>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        <h4 className="recap-titre">Récapitulatif de l'inspection</h4>
        <div className="recap-bloc">
          <h5>Nature du contrôle</h5>
          <div className="grille-champs">
            <ChampLecture label="Nature" valeur="Vérification Générale Périodique (VGP)" />
            <ChampLecture label="N° de contrôle"
              valeur={form.numero_controle || "attribué à la finalisation"} />
            <ChampLecture label="Date" valeur={form.date_controle ? formaterDate(form.date_controle) : ""} />
            <ChampLecture label="Heure" valeur={(form.heure_controle || "").slice(0, 5)} />
            <ChampLecture label="Validité (mois)" valeur={form.validite_mois} />
          </div>
        </div>
        <div className="recap-bloc">
          <h5>Identification véhicule</h5>
          <div className="grille-champs">
            <ChampLecture label="Immatriculation" valeur={vehicule?.immatriculation} />
            <ChampLecture label="Marque" valeur={vehicule?.marque} />
            <ChampLecture label="N° châssis" valeur={vehicule?.n_chassis} />
            <ChampLecture label="Type / modèle" valeur={vehicule?.type_modele} />
            <ChampLecture label="Catégorie" valeur={vehicule ? labelCategorie(vehicule.categorie) : ""} />
            <ChampLecture label="Kilométrage relevé" valeur={form.kilometrage_releve} />
          </div>
        </div>
        <div className="recap-bloc">
          <h5>Identification hayon</h5>
          <div className="grille-champs">
            <ChampLecture label="Marque" valeur={h.marque} />
            <ChampLecture label="Type" valeur={h.type} />
            <ChampLecture label="N° série" valeur={h.n_serie} />
            <ChampLecture label="Année" valeur={h.annee} />
            <ChampLecture label="Capacité de levage (kg)" valeur={h.capacite_levage_kg} />
            <ChampLecture label="Centre de gravité (mm)" valeur={h.centre_gravite_mm} />
            <ChampLecture label="Pression limiteur (bar)" valeur={h.pression_limiteur_bar} />
          </div>
        </div>
        <div className="recap-bloc">
          <h5>Contrôleur</h5>
          <div className="grille-champs">
            <ChampLecture label="Nom" valeur={form.controleur_nom} />
            <ChampLecture label="Prénom" valeur={form.controleur_prenom} />
            <ChampLecture label="Entreprise" valeur={form.controleur_entreprise} />
            <ChampLecture label="Cachet entreprise" valeur={form.cachet_entreprise} />
            <ChampLecture label="Livret de sécurité présent" valeur={livret} />
          </div>
        </div>
        <div className="recap-bloc">
          <h5>Observations constatées</h5>
          {defautsTries.length === 0 ? (
            <p className="vide">Aucune observation constatée.</p>
          ) : (
            <ol className="recap-defauts">
              {defautsTries.map((d, i) => (
                <li key={d.id}>
                  {i + 1}/ {d.description || <span className="champ-manquant">(vide)</span>}
                </li>
              ))}
            </ol>
          )}
        </div>
        <div className="recap-bloc">
          <h5>Essais de fonctionnement</h5>
          <div className="grille-champs">
            <ChampLecture label="À vide — résultat" valeur={form.details.essai_a_vide_resultat} />
            <ChampLecture label="En charge — résultat" valeur={form.details.essai_en_charge_resultat} />
            <ChampLecture label="Charge nominale (kg)" valeur={form.details.charge_nominale_kg} />
          </div>
        </div>
        {/* H3 (28/09/2026) — LA CONCLUSION VIENT EN DERNIER, APRES LE
            RECAPITULATIF. Elle etait a l'etape 1 : le controleur concluait
            avant d'avoir releve une observation ou fait un essai. Ici, il a
            tout sous les yeux au moment de trancher. */}
        <div className="recap-bloc">
          <h5>Conclusion</h5>
          <fieldset className="groupe-radio">
            <legend>Conclusion *</legend>
            {VERDICTS.map((v) => (
              <label key={v} className="option-radio">
                <input type="radio" name="verdict" checked={verdict === v} disabled={ro}
                  onChange={() => majConclusion(v, commentaire)} />
                {v}
              </label>
            ))}
          </fieldset>
          <label className="champ-large">
            Commentaire complémentaire (optionnel)
            <textarea rows={3} value={commentaire} disabled={ro}
              onChange={(e) => majConclusion(verdict, e.target.value)} />
          </label>
        </div>
        {modifiable && (
          <p className="note-info">
            Vérifiez le récapitulatif ci-dessus. Après finalisation, l'inspection passe en lecture
            seule (plus aucune modification possible).
          </p>
        )}
      </>
    );
  }

  return <p className="vide">Contenu de l'étape {etape} à venir.</p>;
}

export default function VgpWizard({ user, onLogout }) {
  return (
    <InspectionWizard
      user={user}
      onLogout={onLogout}
      titre="VGP hayon"
      vocabulaire={VOCABULAIRE_VGP}
      blocsDetails={BLOCS}
      etapes={ETAPES}
      valider={valider}
      renderEtape={renderEtape}
    />
  );
}
